module.exports = {
  home: require('./home').default,
  introduction: require('./introduction').default,
  steps: require('./steps').default,
  room: require('./room').default,
  infobox: require('./infoBox').default,
  info: require('./info').default,
  glossary: require('./glossary').default
};
